import React, { Component } from 'react'
import { List, Filter, Edit, Create, Show, SimpleShowLayout, NumberField, NumberInput, Datagrid, SingleFieldList, ChipField, ReferenceArrayField, ShowButton, ImageField, ImageInput, TextField, EditButton, DisabledInput, SimpleForm, TextInput } from 'admin-on-rest';

const CategoriesFilters = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="query" alwaysOn />
    </Filter>
);

const CategoriesTitle = ({ record }) => {
    return <span>Category {record ? `"${record.name}"` : ''}</span>;
};
export class CategoriesList extends Component {
    render() {
        return (
            <List {...this.props} filters={<CategoriesFilters />}>
                <Datagrid>
                    <TextField source="name" />
                    <ImageField source="thumbnail.url" label="thumbnail" />
                    <NumberField source="index" />
                    <ShowButton />
                    <EditButton />
                </Datagrid>
            </List>
        );
    }
}

export class CategoriesEdit extends Component {
    render() {
        return (
            <Edit {...this.props} title={<CategoriesTitle />}>
                <SimpleForm>
                    <DisabledInput source="id" />
                    <TextInput source="name" />
                    <NumberInput source="index" />
                    <ImageInput source="thumbnail" label="Thumbnail" accept="image/*" multiple={false}>
                        <ImageField source="url" />
                    </ImageInput>
                </SimpleForm>
            </Edit>
        );
    }
}

export class CategoriesCreate extends Component {
    render() {
        return (
            <Create {...this.props}>
                <SimpleForm>
                    <TextInput source="name" />
                    <NumberInput source="index" />
                    <ImageInput source="thumbnail" label="Thumbnail" accept="image/*">
                        <ImageField source="url" />
                    </ImageInput>
                </SimpleForm>
            </Create>
        );
    }
}

export class CategoriesShow extends Component {
    render() {
        return (
            <Show {...this.props} title={<CategoriesTitle />}>
                <SimpleShowLayout>
                    <TextField source="name" />
                    <TextField source="index" />
                    <ImageField source="thumbnail.url" label="Thumbnail" />
                    <ReferenceArrayField label="Foods" source="foods" reference="foods">
                        <SingleFieldList>
                            <ChipField source="name" />
                        </SingleFieldList>
                    </ReferenceArrayField>
                </SimpleShowLayout>
            </Show>
        );
    }
}


// WEBPACK FOOTER //
// ./src/resources/categories.js